import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';

import {
  type TransferReviewBatch,
  type TransferReviewBatchDecision,
  approvalsCreateTransferReviewBatchMutation,
} from '@column/api';

import { useTrackReviewBatchJob } from '~/lib/transfers/stores/ReviewBatchJobs';

export interface ReviewTargets {
  transfer_ids: string[];
  ach_transfer_batch_ids: string[];
}

interface CreateReviewBatchInput {
  decision: TransferReviewBatchDecision;
  targets: ReviewTargets;
  comment?: string;
}

export const useCreateReviewBatch = () => {
  const trackReviewBatchJob = useTrackReviewBatchJob();
  const { mutateAsync } = useMutation(approvalsCreateTransferReviewBatchMutation());

  return useCallback(
    async ({ decision, targets, comment }: CreateReviewBatchInput): Promise<TransferReviewBatch> => {
      const trimmedComment = comment?.trim();
      const batch = await mutateAsync({
        body: { decision, ...targets, ...(trimmedComment ? { comment: trimmedComment } : {}) },
        headers: { 'Idempotency-Key': crypto.randomUUID() },
      });
      trackReviewBatchJob(batch, [...targets.transfer_ids, ...targets.ach_transfer_batch_ids]);
      return batch;
    },
    [mutateAsync, trackReviewBatchJob]
  );
};
